import Home from './Home.add-advertiser.vue'

export default {
    Home
}